import { Component } from 'react';
import { withTranslation } from 'react-i18next';

class Footer extends Component {
    constructor() {
        super();
        this.handleMoodeChange = this.handleMoodeChange.bind(this);
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));

        this.state = {
            isDark: !!isDark,
        };
    }

    async componentDidMount() {
        document.addEventListener('changeMoodEvent', this.handleMoodeChange);
    }
    componentWillUnmount() {
        document.removeEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    handleMoodeChange() {
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));
        this.setState({ isDark });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="footer">
                <img
                    className="footer-icon"
                    src={
                        this.state.isDark
                            ? '/static/img/gddash_logo_dark.png'
                            : '/static/img/gddash_logo1.png'
                    }
                    alt="logo"
                />
                {t('footer.powered_by')}
                <img
                    className="footer-icon"
                    src={
                        this.state.isDark
                            ? '/static/img/newzdash_icon_dark.png'
                            : '/static/img/newzdash-icon.svg'
                    }
                    alt="logo"
                />
            </div>
        );
    }
}

export default withTranslation()(Footer);
